import request from '@/service/request';

export const login = (data: {
  phone_number: string;
  password: string;
  phone_area_code: string;
}) => {
  return request.post(
    `/v2/admin_account/login/platform/Agency/phone_password`,
    {
      data,
    },
  );
};

export const resetPassword = (data: { email: string }) => {
  return request.post(`${ADMIN_PREFIX}/login/forget`, { data });
};

export const getAgencyInfo = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/user_info');
};

export const setPaymentPassword = (data: {
  payment_password: string;
  old_payment_password?: string;
}) => {
  return request.put(
    '/v1/agency-platform-vn-v2/agency/user_info/payment_password',
    {
      data,
    },
  );
};
